import VSelectSubTeacher from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectSubTeacher', VSelectSubTeacher),
};
